import { format, addMonths } from "date-fns";
import { ChevronLeft, ChevronRight } from "@/icons";
import { cn } from "@/utils";
import { useCallback } from "react";

interface MonthSelectorProps {
  month: Date;
  setMonth: (newMonth: Date) => void;
  isMinMonth: (date: Date) => boolean;
  isMaxMonth: (date: Date) => boolean;
  className?: string;
}

export const MonthSelector = ({
  month,
  setMonth,
  isMinMonth,
  isMaxMonth,
  className,
}: MonthSelectorProps) => {
  const changeMonth = useCallback(
    (increment: number) => {
      const newMonthDate = addMonths(month, increment);
      setMonth(newMonthDate);
    },
    [month, setMonth],
  );

  return (
    <div className={cn("h5-bold flex select-none", className)}>
      <div>
        <ChevronLeft
          className={cn(
            "h-5, w-5",
            isMinMonth(month) ? "text-item-disabled" : "cursor-pointer",
          )}
          onClick={!isMinMonth(month) ? () => changeMonth(-1) : undefined}
        />
      </div>
      <div className="flex min-w-[150px] justify-center gap-1">
        <span>{format(month, "MMMM")}</span>
        <span className="text-item-disabled">{format(month, "yyyy")}</span>
      </div>
      <div>
        <ChevronRight
          className={cn(
            "h-5, w-5",
            isMaxMonth(month) ? "text-item-disabled" : "cursor-pointer",
          )}
          onClick={!isMaxMonth(month) ? () => changeMonth(1) : undefined}
        />
      </div>
    </div>
  );
};
